var hamburguerElement = document.getElementById("menu-toggle");
var wrapper = document.getElementById("wrapper");
var myProfileElement = document.getElementById("user-profile-toggle");

var errorSetUp = document.getElementById("errorSetUp");
var backButton = document.getElementById("back-button");
var companiesError = document.getElementById("companiesInfoError");

/* Redirects the user to the logoff page half minute before session ends in server. */
/* Note: Maximum supported delay for modern browsers is int32 max value: 2147483647. */
const signOutUrl = document.getElementById("sign-out-url") as HTMLInputElement;
const sessionTimeout = Number((document.getElementById("sign-out-timeout") as HTMLInputElement).value);
window.setTimeout(function () {
    if (signOutUrl !== null && signOutUrl !== undefined) {
        window.location.href = window.location.origin + signOutUrl.value;
    }
}, sessionTimeout*60*1000 - 1*60*500);

/*Behavior of hamburguer menu*/
if (hamburguerElement !== null) {
    hamburguerElement.onclick = function () {
        // If my profile dropdown is open 
        if (wrapper.classList.contains("active-profile")) {
            //Close my profile dropdown
            closeMyProfil();
        }
        checkHamburguerMenuStatus();
    }
};
/*Behavior of my profile content*/
if (myProfileElement !== null) {
    myProfileElement.onclick = function () {
        // If hamburguer menu is open 
        if (wrapper.classList.contains("active")) {
            //Close hamburger menu
            closeHamburguerMenu();
        }
        checkMyProfileStatus();
    }
};
// Check hamburguer menu status to close it or open it
function checkHamburguerMenuStatus() {
    // If my profile is open
    if (wrapper.classList.contains("active")) {
        //Close my hamburguer menu
        closeHamburguerMenu();
    }
    else {
        //open my hamburguer menu
        wrapper.classList.add("active");
        if (companiesError !== null) {
            companiesError.classList.add("hide");
        }
        if (document.getElementById("hamburguerIcon") !== null) {
            document.getElementById("hamburguerIcon").classList.add("hamburger-shadow");
        }
    }
}
// Check my profile dropdown status to close it or open it
function checkMyProfileStatus() {
    // If my profile is open
    if (wrapper.classList.contains("active-profile")) {
        //Close my profile dropdown
        closeMyProfil();
    }
    else {
        //Open my profile dropdow
        wrapper.classList.add("active-profile");
        if (companiesError !== null) {
            companiesError.classList.add("hide");
        }
        if (document.getElementById("user-profile-toggle") !== null) {
            document.getElementById("user-profile-toggle").classList.add("hamburger-shadow");
            wrapper.insertAdjacentHTML('afterend', '<div class="backdrop fade-profile" id="profile-backdrop"></div>');
        }
        var profileBackground = document.getElementById("profile-backdrop");
        if (profileBackground !== null) {
            setTimeout(function () { profileBackground.classList.add("show"); }, 200);
            document.getElementsByTagName("body")[0].classList.add("backdrop-open");
        }
    }
}

//function to close my perfil dropdown
function closeMyProfil() {
    wrapper.classList.remove("active-profile");
    if (myProfileElement !== null) {
        myProfileElement.classList.remove("hamburger-shadow");
    }
    var profileBackground = document.getElementById("profile-backdrop");
    if (profileBackground !== null && profileBackground !== undefined) {
        profileBackground.classList.remove("show");
        setTimeout(function () { profileBackground.remove(); }, 200);
        document.getElementsByTagName("body")[0].classList.remove("backdrop-open");
    }
};

//function to close hamburguer menu
function closeHamburguerMenu() {
    wrapper.classList.remove("active");
    if (document.getElementById("hamburguerIcon") !== null) {
        document.getElementById("hamburguerIcon").classList.remove("hamburger-shadow");
    };
};

// Click on background of my profile to close it 
if ((document.getElementById("profile-wrapper")) !== null) {
    document.getElementById("profile-wrapper").onclick = function () {
        // If my profile is open
        if (wrapper.classList.contains("active-profile")) {
            //Close my profile dropdown
            closeMyProfil();
        }
    };
};

if ((document.getElementById("profile-info-container")) !== null) {
    document.getElementById("profile-info-container").onclick = function () {
        // Stop event of closing dropdown
        event.stopPropagation();
    };
};

//Check if the actual view is landing screen to hide back button
if (errorSetUp !== null && backButton !== null && companiesError !== null) {
    backButton.classList.add("hide");
};
/*Company dropdown behavior*/
if (document.getElementById("CompanySelectDropDown") !== null) {
    document.getElementById("CompanySelectDropDown").onchange = function (org) {
        var select = document.getElementById("CompanySelectDropDown") as HTMLSelectElement;
        var wrapper = document.getElementById("wrapper");
        var valueSelected = select.options[select.selectedIndex].value;
        wrapper.classList.remove("active");
        if (valueSelected !== "selectOption") {
            var context = JSON.parse(valueSelected);
            var companyNumberInput = document.getElementById("companyNumberInput") as HTMLInputElement;
            companyNumberInput.value = context.CompanyNumber;
            var tenantIdInput = document.getElementById("tenantIdInput") as HTMLInputElement;
            tenantIdInput.value = context.TenantId;

            var companySelectionForm = document.getElementById("companySelectionForm") as HTMLFormElement;
            companySelectionForm.submit();
        }
    };
}


/*Accept/Denny of exception's buttons functionality*/
if ((document.getElementById("submitApprove")) !== null) {
    document.getElementById("submitApprove").addEventListener("click", function () {
        var comments = (<HTMLInputElement>document.getElementById("commentTextBox")).value;
        (<HTMLInputElement>document.getElementById("commentsApprove")).value = comments;
    });
}
if ((document.getElementById("submitDecline")) !== null) {
    document.getElementById("submitDecline").addEventListener("click", function () {
        var comments = (<HTMLInputElement>document.getElementById("commentTextBox")).value;
        (<HTMLInputElement>document.getElementById("commentsDecline")).value = comments;
    });
}
if ((document.getElementById("submitPromote")) !== null) {
    document.getElementById("submitPromote").addEventListener("click", function () {
        var comments = (<HTMLInputElement>document.getElementById("commentTextBox")).value;
        (<HTMLInputElement>document.getElementById("commentsPromote")).value = comments;
    });
}

/*Managment of List of exceptions in decide tab when it's empty*/
var listOfException = document.getElementById("list-of-exceptions");
var headerOfList = document.getElementById("header-list-of-exceptions");
if (listOfException !== null && headerOfList != null) {
    var listItem = listOfException.getElementsByTagName("li");
    if (listItem !== null) {
        let lengthOfList = listItem.length;
        if (lengthOfList === 0) {
            headerOfList.innerHTML = "There are no exceptions";
        }
    }
}

(function ($) {
    $("#sla-modal").on("hidden.bs.modal", function () {
        $("#dashboard-dropdown").val($("#dashboard-dropdown option:first").val());
        $("#form-hourly-metrics button").attr('disabled', 'disabled');
    });

    $("#dashboard-dropdown").on('change', function (e) {
        let dropdown = $("#dashboard-dropdown");
        let controlValue = dropdown.val();
        if (dropdown.prop('selectedIndex') > 0) {
            $("#form-hourly-metrics button").removeAttr('disabled').focus();
        }
        else {
            $("#form-hourly-metrics button").attr('disabled', 'disabled').focus();
        }
        $("#form-hourly-metrics button").focus();
    });

    $("#sla-dashboard-menu-option").on("click", function () {
        if ($("#DataType").val() === "SLADashboard") {
            closeHamburguerMenu();
        }
    });
}(jQuery));

$(document).ready(function () {
    if ($("#dashboard-dropdown").length > 0) {
        $("#dashboard-dropdown").val($("#dashboard-dropdown option:first").val());
        $("#form-hourly-metrics button").attr('disabled', 'disabled');
    }
});